<template>
	<div class="clauseBox">
		<p>Pomelo Co., Limited 개인 정보 보호 정책 
		</p><p>발효일: 2025년 6월 3일 
		</p><p>개발자: Pomelo Co., Limited
		</p><p>============================================ 
		</p><p>1. 데이터 수집 유형 및 목적 
		</p><p>-------------------------------------------- 
		</p><p>1.1 사용자가 제공한 데이터 
		</p><p>- Google/Facebook 로그인 정보(이름, 이메일, 계정 ID) 
		</p><p>- 휴대폰 번호(인증/고객센터용) 
		</p><p>- 사용자가 생성한 사진 / 비디오 / 녹음 
		</p><p>1.2 자동으로 수집된 데이터 
		</p><p>- 장치 정보(IMEI, Android ID, MAC 주소) 
		</p><p>- 비헤이비어 사용 (세션 시간, 기능 사용 빈도) 
		</p><p>- 광고 상호 작용 데이터 (클릭, 표시, 전환) 
		</p><p>1.3 권한 사용 설명 
		</p><p>⑥ 권한 _ 용도 
		</p><p>|---------------------|--------------------------------------| 
		</p><p>▲ READ_PHONE_STATE = 전화 상태를 인식하여 게임/재생을 일시 중지합니다. 
		</p><p>RECORD_AUDIO - 음성 메시지 기록 및 음성 제어 기능 
		</p><p>▲ CAMERA = 사진 촬영/비디오 방송/AR 기능 
		</p><p>WRITE_EXTERNAL_STORAGE - 사용자가 생성한 미디어 파일 저장   |
		</p><p>
		</p><p>============================================
		</p><p>2. 타사 SDK 데이터 공유 인벤토리 
		</p><p>-------------------------------------------- 
		</p><p>2.1 분석 도구 SDK 
		</p><p>▲ SDK 이름 ▲ 정책 링크 ▲ 수집 데이터 유형 ▲ 
		</p><p>|-----------------------|--------------------------------------|----------------------------| 
		</p><p>| Google Analytics      | https://policies.google.com/privacy충돌 보고서, 이벤트 로그 적용 
		</p><p>| Firebase             | https://firebase.google.com/terms/⑥ 장치 모델, 설치 소스 
		</p><p>| Unity Analytics       | https://unity.com/legal/privacy-policy게임 진행률, 가상 아이템 획득 
		</p><p>Bugly(텐센트)https://privacy.qq.com/• 예외 스택, 메모리 사용량 
		</p><p>| Cocos2D               | https://www.cocos.com/privacy• 렌더링 성능, 장치 GPU 정보
		</p><p>2.2 광고 SDK 
		</p><p>▲ SDK 이름 ▲ 정책 링크 ▲ 공유 데이터 유형 ▲ 
		</p><p>|-----------------------|--------------------------------------|----------------------------| 
		</p><p>| Google AdMob          | https://policies.google.com/privacy  | Android ID、광고 클릭 ID 
		</p><p></p><p>| Facebook Audience     | https://www.facebook.com/about/privacy⑥ 장치 언어, 시간대 설정 
		</p><p>| TradPlus              | https://www.tradplus.com/privacy-policy/네트워크 유형, 사업자 정보 
		</p><p>| InMobi                | https://www.inmobi.com/privacy-policy/ | GAID、대략적인 지리적 위치 
		</p><p>| Mintegral             | https://www.mintegral.com/en/privacy/화면 방향, 배터리 충전 
		</p><p>| Vungle                | https://vungle.com/privacy/광고 시청 시간, 장비 브랜드 
		</p><p>| AppLovin              | https://www.applovin.com/privacy/설치 애플리케이션 목록(일부 지역) 
		</p><p>Pangle(바이트댄스)https://www.pangleglobal.com/privacyIP 주소, 사용자 프록시 문자열
		</p><p>
		</p><p>2.3 로그인 서비스 SDK 
		</p><p>▲ SDK 이름 ▲ 정책 링크 ▲ 데이터 획득 범위 ▲ 
		</p><p>|-----------------------|--------------------------------------|----------------------------| 
		</p><p>| Google Sign-In        | https://policies.google.com/privacy▲ 프로파일, Google 계정 ID = 
		</p><p>| Facebook Login        | https://www.facebook.com/about/privacy프로필, 친구 목록 공개
		</p><p>============================================
		</p><p>3. 데이터 사용 목적 
		</p><p>-------------------------------------------- 
		</p><p>1. 계정 관리(소셜 로그인) 
		</p><p>2. 핵심 기능 구현(미디어 프로세싱/게임 실행) 
		</p><p>3.광고 개성화 투입과 수익 최적화 
		</p><p>4. 안정성 모니터링 적용(충돌 분석) 
		</p><p>5. 안전 보호(커닝 방지 시스템) 
		</p><p>============================================ 
		</p><p>4. 데이터 저장 및 보안 
		</p><p>-------------------------------------------- 
		</p><p>1. 저장 위치: 
		</p><p></p><p>- 사용자 데이터: Google Cloud(미국) 
		</p><p>- 미디어 파일: AWS S3(싱가포르) 
		</p><p>- 로그 데이터: 알리 클라우드 (홍콩)
		</p><p>
		</p><p>2. 안전 조치: 
		</p><p>- TLS 1.3 암호화 전송 
		</p><p>- 민감한 데이터 SHA-256 해시 처리 
		</p><p>- 분기별 침투 테스트 
		</p><p>3. 보존 기간: 
		</p><p>- 계정 데이터: 사용자가 로그아웃할 때까지 
		</p><p>- 동작 로그: 90일 자동 삭제 
		</p><p>- 광고 데이터: 30일 익명 처리 
		</p><p>============================================ 
		</p><p>5. 사용자 권리 
		</p><p>-------------------------------------------- 
		</p><p>설정 > 개인 정보 보호 센터에서 다음을 수행할 수 있습니다. 
		</p><p>1. 데이터 내보내기: 개인 데이터 사본 가져오기(CSV 형식) 
		</p><p>2. 계정 삭제: 72시간 이내에 모든 관련 데이터 영구 삭제 
		</p><p>3. SDK 제어: 각 SDK 데이터 수집 상태 보기
		</p><p>
		</p><p>광고 개인화 관리: 
		</p><p>- 광고 ID 재설정: Android 설정 → Google → 광고 
		</p><p>- 글로벌 종료 옵션: 
		</p><p>* DAA：https://optout.aboutads.info/ 
		</p><p>* EDAA：https://www.youronlinechoices.com/ 
		</p><p>============================================ 
		</p><p>6. 어린이 프라이버시 보호 
		</p><p>-------------------------------------------- 
		</p><p>- 이 앱은 13세 미만 어린이를 대상으로 하지 않습니다. 
		</p><p>- 어린이 데이터가 수집된 경우 다음을 참조하십시오.childsafe@yourdomain.com 
		</p><p>- COPPA 요구 사항에 따라 즉시 관련 데이터 삭제 
		</p><p>============================================ 
		</p><p>7. 국제 데이터 전송 
		</p><p>-------------------------------------------- 
		</p><p>데이터는 다음 지역으로 전송될 수 있습니다. 
		</p><p>- 미국 (Google/Facebook/Vungle) 
		</p><p>- 중국 (TradPlus/Bugly/Pangle) 
		</p><p>- 싱가포르(AWS 서버)
		</p><p>
		</p><p>전송 기준: 
		</p><p>- GDPR 표준 계약 조건(SCCs) 
		</p><p>- APEC 국경 간 개인 정보 보호 규칙(CBPR) 
		</p><p>============================================ 
		</p><p>8. 정책 갱신 
		</p><p>-------------------------------------------- 
		</p><p>- 최신 버전:https://yourdomain.com/privacy 
		</p><p>- 히스토리 버전:https://yourdomain.com/privacy/archive 
		</p><p>- 주요 변경 사항은 적용 시 알림 (3회 알림) 
		</p><p>============================================ 
		</p><p>9. 저희에게 연락하세요 
		</p><p>-------------------------------------------- 
		</p><p>데이터 보호 책임자:ylqyd369@gmail.com 
		</p><p>유럽 연합 대표:ylqyd369@gmail.com(GDPR 제 27 조에 따라) 
		</p><p>미국 CCPA 요청:ylqyd369@gmail.com 
		</p><p>중국 불만:ylqyd369@gmail.com 
		</p><p>응답 시간: 
		</p><p>- 데이터 삭제 요청: 72시간 이내 
		</p><p>- 일반 문의: 48시간 이내
		</p><p>
		</p><p>============================================ 
		</p><p>법적 고지 사항 
		</p><p>-------------------------------------------- 
		</p><p>본 정책은 다음 규정에 따라 제정됩니다. 
		</p><p>1. Google Play 개발자 정책(2025년 4월) 
		</p><p>2. GDPR(EU 범용 데이터 보호 규정) 
		</p><p>3. CCPA(캘리포니아 소비자 개인 정보 보호 법안) 
		</p><p>4. PIPL(중국 개인정보보호법) 
		</p><p>특별 성명: 
		</p><p>- Unity/Bugly/Cocos2D SDK는 필요한 기술 데이터만 수집 
		</p><p>- 전화 권한은 통화 기록 / 연락처를 가져오는 데 사용되지 않습니다. 
		</p><p>- 사용자가 활성화된 경우에만 녹음 권한 활성화 
		</p><p>광고 SDK 규정 준수 지침: 
		</p><p>모든 광고 SDK 구성: 
		</p><p>- GDPR 동의 관리(Google UMP SDK를 통해) 
		</p><p>- COPPA 어린이 보호 모드 
		</p><p>- CCPA "매각하지 마세요" 표시 
		</p><p>============================================
		</p>
	</div>
</template>

<script>
</script>

<style>
</style>